'use strict';
const angular = require('angular');

export default angular.module('wftOrderFormApp.resultControls', [])
  .directive('resultControls', function() {
    return {
      template: require('./resultControls.html'),
      restrict: 'E',
      replace: true,
      scope: {
        total: '<',
        pageSizeOptions: '<',
        pageSize: '=',
        pageSizeCallback: '&',
        sortByOptions: '<',
        sortBy: '=',
        sortByCallback: '&'
      },
      link: function(scope, element, attrs) {
        scope.sortByDir = 'asc';

        if(scope.sortBy) {
          let sortBy = [];
          if(/\s/.test(scope.sortBy)) {
            sortBy = scope.sortBy.split(/\s/);
          } else {
            sortBy = [sortBy];
          }
          scope.sortByField = sortBy[0];
          scope.sortByDir = sortBy[1] && sortBy[1] === 'asc' ? 'asc' : 'desc';
        }

        scope.updateSortByField = function() {
          if(!scope.sortByField) {
            return scope.sortByCallback({sortBy: scope.sortByField});
          }
          scope.sortByCallback({sortBy: `${scope.sortByField} ${scope.sortByDir}`});
        };

        scope.updateSortByDir = function() {
          scope.sortByDir = scope.sortByDir === 'asc' ? 'desc' : 'asc';
          scope.sortByCallback({sortBy: `${scope.sortByField} ${scope.sortByDir}`});
        };
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directives/resultControls/resultControls.directive.js